<template>
  <scrollable-container>
    <tabset :tabs="tabs" />
    <keep-alive>
      <router-view />
    </keep-alive>
  </scrollable-container>
</template>

<script>
  import Tabset from '@/components/common/tabs/tabset.vue';
  import ScrollableContainer from '@/components/common/blocks/scrollable-container.vue';

  export default {
    components: {
      Tabset,
      ScrollableContainer,
    },
    data() {
      return {
        tabs: [
          {
            title: this.$t('reports.employeeReport'),
            route: { name: 'employeeReport' },
          },
          {
            title: this.$t('reports.employeePrintingReport'),
            route: { name: 'employeePrintReport' },
          },
        ],
      };
    },
  };
</script>
